import type { AuthenticatedUser } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { DEFAULT_INITIAL_PAGE_SIZE } from '@frameio/utils/constants';
import { useGetInboxAccountsQuery } from '../gql/generated/GetInboxAccounts';

export const useActiveInboxAccount = () => {
  const activeAccountId = useActiveAccountId();

  const { data, loading } = useGetInboxAccountsQuery({
    variables: { page: { first: DEFAULT_INITIAL_PAGE_SIZE } },
  });
  const me = data?.me as AuthenticatedUser;

  const inboxAccount = me?.inboxAccounts?.nodes?.find(
    (a) => a?.id === activeAccountId
  );

  return {
    inboxAccount,
    loading,
  };
};
